import React, { Component } from 'react';
import _ from 'lodash';
import Modal from 'react-modal-es';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { closeModal } from './Modal';

const wrapper = {
  top: '50%'
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick} aria-hidden>
      <i className="icon-arrow-right" />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick} aria-hidden>
      <i className="icon-arrow-left" />
    </div>
  );
};

const mapStateToProps = ({ products, settings, domain }) => {
  const selectedProduct = _.get(domain, 'selectedProduct');

  return {
    catalog: _.get(settings, 'basic_catalog'),
    products,
    selectedProduct
  };
};

class ProductModal extends Component {
  constructor(props) {
    super(props);
    this.productModal = React.createRef();
    this.myRef = React.createRef();
    this.productThumbnail = React.createRef();
    this.currentSlider = 0;
    this.state = {
      // currSlide: 0
    };
  }

  static propTypes = {
    image: PropTypes.string.isRequired
  };

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.data.id !== this.props.data.id) {
  //     this.resetCurrentSlide();
  //   }
  // }

  // resetCurrentSlide = () => {
  //   this.setState({
  //     currSlide: 0
  //   });
  // }

  handleCloseModal = () => {
    closeModal('modal-preview-gallery');
  };

  // handleOpenCatalog = (galleryProducts) => {
  //   const catalogUrl = _.get(galleryProducts, `${this.currentSlider}.catalog`, '');
  //   // if (catalogUrl)
  //   window.open(catalogUrl, '_blank');
  // }

  render() {
    // const { currSlide } = this.state;
    const { selectedProduct, getContentLanguage, name, products, catalog: basicCatalog, language } = this.props;
    // const gallery = _.get(selectedProduct, 'acf.gallery', []);
    // const galleryContent =
    //   _.size(gallery) > 0
    //     ? gallery
    //     : [_.get(selectedProduct, ['acf', 'cover_image'], []), ''];
    // const specfication = _.get(selectedProduct, 'acf.specfication', []);

    // const galleryProducts = _.map(products, (product, index) => {
    //   if (_.get(selectedProduct, 'id', 0) === product.id) this.currentSlider = index;
    //   const title = _.get(product, 'title.rendered', '');
    //   const url = _.get(product, ['acf', 'cover_image', 'url'], null);
    //   const catalog = _.get(product, ['acf', 'catalog', 'url'], null);
    //   const specfication = _.get(product, 'acf.specfication', []);
    //   return {
    //     title,
    //     url,
    //     catalog,
    //     specfication,
    //   };
    // });

    const galleryProducts = _.map(_.get(products, language), (product, index) => {
      if (_.get(selectedProduct, 'id', 0) === product.id) this.currentSlider = index;
      const title = _.get(product, 'title.rendered', '');
      const url = _.get(product, ['acf', 'cover_image', 'url'], null);
      const catalog = _.get(product, ['acf', 'catalog', 'url'], null);
      const specfication = _.get(product, 'acf.specfication', []);
      return {
        title,
        url,
        catalog,
        specfication,
      };
    });

    const settings = {
      // dots: true,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      center: false,
      initialSlide: this.currentSlider,
      beforeChange: (oi, i) => this.productThumbnail.current.slickGoTo(i),
    };

    const thumbnailSliderSetting = {
      dots: false,
      initialSlide: this.currentSlider,
      arrows: false,
      slidesToShow: _.size(galleryProducts) < 6 ? _.size(galleryProducts) : 6,
      // slidesToShow: 6,
    };
    // console.log('Model', galleryProducts);
    return (
      <Modal
        name={name}
        center
        title="Search Modal2"
        overlayColor="#F7F7F7"
        wrapper={wrapper}
        didOpen={() => (document.body.style.overflowY = 'hidden')}
        willClose={() => (document.body.style.overflowY = 'scroll')}
      >
        <div className="content">
          <div className="line" />
          <div className="modal-preview-image">
            <Slider {...settings} ref={this.productModal}>
              {_.map(galleryProducts, (item, index) => {
                return (
                  <div key={`img-${index}`} className="wrap-image">
                    <div className="cover-image">
                      <div className="title row justify-content-between">
                        <div className="col">
                          <h3
                            className="whiteGray"
                            dangerouslySetInnerHTML={{
                              __html: _.get(item, 'title')
                            }}
                          />
                        </div>

                        <div
                          className="close-button col-2 col-md-1"
                          aria-hidden
                          onClick={this.handleCloseModal}
                        >
                          <i className="icon-close" />
                        </div>
                      </div>

                      <div className="detail row no-gutters justify-content-between">
                        <div className="detail-left-mobile">
                          <h3 className="whiteGray spec-title no-wrape spec-col col ">
                            {`${index + 1}/${_.size(galleryProducts)}`}
                          </h3>
                        </div>
                        <div className="d-flex">
                          <div className="spec-col col">
                            <div className="name-head gold">
                              <h3 className="lightGray spec-title no-wrape ">
                                {getContentLanguage('name')}
                              </h3>
                            </div>
                            <div className="name-head gold1">
                              <h3 className="lightGray spec-title no-wrape ">
                                {getContentLanguage('width')}
                              </h3>
                            </div>
                          </div>
                          {_.map(item.specfication, spec => (
                            <div className="spec-col col">
                              <div className="name-head gold">
                                <h3 className="whiteGray spec-title no-wrape ">
                                  {spec.name}
                                </h3>
                              </div>
                              <div className="name-head gold">
                                <h3 className="whiteGray spec-title no-wrape ">
                                  {spec.width}
                                </h3>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="detail-left d-flex">
                          <h3 className="whiteGray spec-title no-wrape spec-col col ">
                            {`${index + 1}/${_.size(galleryProducts)}`}
                          </h3>
                          <div className="hold-arrow spec-col col">
                            <SamplePrevArrow
                              onClick={() => {
                                this.productModal.current.slickPrev();
                              }}
                              className="button-arrow"
                            />
                          </div>

                          <div className="hold-arrow spec-col col">
                            <SampleNextArrow
                              onClick={() =>
                                this.productModal.current.slickNext()
                              }
                              className="button-arrow"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      style={{ width: '100%' }}
                      src={_.get(item, 'url')}
                      alt=""
                    />
                  </div>
                );
              })}
            </Slider>
            <div className="slider-thumnail">
              <div
                className="slider-wrapper"
              >
                <Slider
                  ref={this.productThumbnail}
                  {...thumbnailSliderSetting}
                >
                  {_.map(galleryProducts, (item, index) => {
                    return (
                      <img
                        src={_.get(item, 'url')}
                        alt=""
                        aria-hidden
                        onClick={() => this.productModal.current.slickGoTo(index)}
                        className="img-thumbnail"
                      />
                    );
                  })}
                </Slider>
              </div>
              {
                !_.isEmpty(basicCatalog) && (
                  <div className="download-cat-wrapper">
                    <a
                      href={_.get(basicCatalog, ['url'])}
                      className="download-cat-button"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <h4 className="navGold">
                        {getContentLanguage('download-catalog')}
                      </h4>
                    </a>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect(mapStateToProps)(ProductModal);



// WEBPACK FOOTER //
// ./src/components/ProductModal.js